import { render, staticRenderFns } from "./TicketTask.vue?vue&type=template&id=edc124ae&scoped=true"
import script from "./TicketTask.vue?vue&type=script&lang=js"
export * from "./TicketTask.vue?vue&type=script&lang=js"
import style0 from "./TicketTask.vue?vue&type=style&index=0&id=edc124ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc124ae",
  null
  
)

export default component.exports